import { lazyView } from '../../app/lazyView.js';
import type { ViewComponent } from '../../app/Shell.js';

// Layar kelompok "nota" → komponen (lihat features/PORTING.md). Owner & admin (menu NAV v1).
export const views: Record<string, ViewComponent> = {
  operasi: lazyView(() => import('./Operasi.js')),
  nota: lazyView(() => import('./Nota.js')),
  rute: lazyView(() => import('../rute/Rute.js')),
};
